import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Styles from './styles';
export function FigsLoader({ size = '50px', title = 'Loading...', className }) {
    return (_jsxs(Styles.Wrapper, { size: size, className: className, children: [_jsx(Styles.LogoBadge, { "aria-describedby": 'loader-title', children: _jsx("title", { id: 'loader-title', children: title }) }), _jsx(Styles.SpinnerOverlay, {})] }));
}
//# sourceMappingURL=index.js.map